<template>
  <div class="moreBtn">
    {{ title }}
    <el-icon v-if="showArrow" style="margin-left: 0.5rem" size="16">
      <DArrowRight />
    </el-icon>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  title: String,
  showArrow: {
    type: Boolean,
    default: false
  }
});
</script>

<style lang="scss" scoped>
.moreBtn {
  display: block;
  padding: 0 1rem;
  height: 2.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 1rem;
  background: #32A89E;
  border-radius: 0.5rem;
  cursor: pointer;
}
</style>
